import React from 'react';
export const userOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14.8501 7.94999C14.8501 6.37517 13.5749 5.09999 12.0001 5.09999C10.4253 5.09999 9.1501 6.37517 9.1501 7.94999C9.1501 9.52481 10.4253 10.8 12.0001 10.8C13.5749 10.8 14.8501 9.52481 14.8501 7.94999ZM16.6501 7.94999C16.6501 10.5189 14.569 12.6 12.0001 12.6C9.43117 12.6 7.3501 10.5189 7.3501 7.94999C7.3501 5.38106 9.43117 3.29999 12.0001 3.29999C14.569 3.29999 16.6501 5.38106 16.6501 7.94999ZM5.9001 18.4286C5.9001 19.1974 5.80933 19.1 6.23539 19.1H17.7648C18.1909 19.1 18.1001 19.1974 18.1001 18.4286C18.1001 16.536 15.3219 15.4 12.0001 15.4C8.67829 15.4 5.9001 16.536 5.9001 18.4286ZM4.1001 18.4286C4.1001 15.1018 7.77289 13.6 12.0001 13.6C16.2273 13.6 19.9001 15.1018 19.9001 18.4286C19.9001 20.1642 19.2146 20.9 17.7648 20.9H6.23539C4.78564 20.9 4.1001 20.1642 4.1001 18.4286Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const userAddBadgeOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M14 13.5C17.0376 13.5 19.5 11.0376 19.5 8C19.5 4.96243 17.0376 2.5 14 2.5C10.9624 2.5 8.5 4.96243 8.5 8C8.5 11.0376 10.9624 13.5 14 13.5ZM14 11.5C15.933 11.5 17.5 9.933 17.5 8C17.5 6.067 15.933 4.5 14 4.5C12.067 4.5 10.5 6.067 10.5 8C10.5 9.933 12.067 11.5 14 11.5Z'
        fill='#023F80'
      />
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M19 26C22.3137 26 25 23.3137 25 20C25 16.6863 22.3137 14 19 14C15.6863 14 13 16.6863 13 20C13 23.3137 15.6863 26 19 26ZM20 17C20 16.4477 19.5523 16 19 16C18.4477 16 18 16.4477 18 17V19H16C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H18V23C18 23.5523 18.4477 24 19 24C19.5523 24 20 23.5523 20 23V21H22C22.5523 21 23 20.5523 23 20C23 19.4477 22.5523 19 22 19H20V17Z'
        fill='#023F80'
      />
      <path
        d='M11.1874 17.7386C11.7299 17.6351 12.0858 17.1114 11.9823 16.5689C11.8788 16.0264 11.3551 15.6706 10.8126 15.7741C8.0848 16.2945 6.58492 17.488 5.79183 18.6829C5.40455 19.2664 5.20687 19.8191 5.1061 20.2361C5.05572 20.4446 5.02927 20.6203 5.01537 20.7509C5.00842 20.8163 5.00458 20.8707 5.00248 20.9126C5.00143 20.9336 5.00081 20.9514 5.00045 20.966L5.00009 20.9855L5.00002 20.9933L5 20.9968L5 20.9984C5 20.9984 5 20.9999 6 20.9999H5V21.4999C5 22.8806 6.11929 23.9999 7.5 23.9999H10.5C11.0523 23.9999 11.5 23.5522 11.5 22.9999C11.5 22.4476 11.0523 21.9999 10.5 21.9999H7.5C7.22386 21.9999 7 21.7761 7 21.4999V21.0121C7.00037 21.0049 7.00144 20.988 7.00416 20.9625C7.00979 20.9095 7.02241 20.8207 7.05015 20.7059C7.10563 20.4763 7.22045 20.1471 7.45817 19.7889C7.91508 19.1005 8.9152 18.1722 11.1874 17.7386Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const usersOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M17.0001 13.5C20.6885 13.5 23.9001 14.8092 23.9001 17.7571C23.9001 19.3112 23.2564 20 21.9413 20L16.3454 20C15.8022 20 15.4184 19.449 15.5257 18.9165C15.601 18.5429 15.9146 18.2 16.2957 18.2001C18.555 18.2004 22.0781 18.202 22.0781 18.202C22.0781 18.202 22.1001 17.9052 22.1001 17.7571C22.1001 16.2449 19.7822 15.3 17.0001 15.3C16.528 15.3 16.0693 15.3272 15.633 15.3798C15.2978 15.4202 14.9733 15.2608 14.7834 14.9816C14.4324 14.4658 14.6173 13.6856 15.2363 13.6071C15.8032 13.5352 16.3952 13.5 17.0001 13.5ZM7.0001 13.5C10.6885 13.5 13.9001 14.8092 13.9001 17.7571C13.9001 19.3112 13.2564 20 11.9413 20H2.05892C0.743807 20 0.100098 19.3112 0.100098 17.7571C0.100098 14.8092 3.31165 13.5 7.0001 13.5ZM7.0001 15.3C4.21796 15.3 1.9001 16.2449 1.9001 17.7571C1.9001 17.9059 1.9201 18.202 1.9201 18.202H12.0781C12.0781 18.202 12.1001 17.9052 12.1001 17.7571C12.1001 16.2449 9.78224 15.3 7.0001 15.3ZM17.0001 4.20001C19.2928 4.20001 21.1501 6.05733 21.1501 8.35001C21.1501 10.6427 19.2928 12.5 17.0001 12.5C14.7074 12.5 12.8501 10.6427 12.8501 8.35001C12.8501 6.05733 14.7074 4.20001 17.0001 4.20001ZM7.0001 4.20001C9.29278 4.20001 11.1501 6.05733 11.1501 8.35001C11.1501 10.6427 9.29278 12.5 7.0001 12.5C4.70742 12.5 2.8501 10.6427 2.8501 8.35001C2.8501 6.05733 4.70742 4.20001 7.0001 4.20001ZM17.0001 6.00001C15.7015 6.00001 14.6501 7.05144 14.6501 8.35001C14.6501 9.64858 15.7015 10.7 17.0001 10.7C18.2987 10.7 19.3501 9.64858 19.3501 8.35001C19.3501 7.05144 18.2987 6.00001 17.0001 6.00001ZM7.0001 6.00001C5.70153 6.00001 4.6501 7.05144 4.6501 8.35001C4.6501 9.64858 5.70153 10.7 7.0001 10.7C8.29867 10.7 9.3501 9.64858 9.3501 8.35001C9.3501 7.05144 8.29867 6.00001 7.0001 6.00001Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const usersGroup = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        id='Vector'
        d='M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM4 5V19H20V7H11.586L9.586 5H4ZM8 18C8 16.9391 8.42143 15.9217 9.17157 15.1716C9.92172 14.4214 10.9391 14 12 14C13.0609 14 14.0783 14.4214 14.8284 15.1716C15.5786 15.9217 16 16.9391 16 18H8ZM12 13C11.337 13 10.7011 12.7366 10.2322 12.2678C9.76339 11.7989 9.5 11.163 9.5 10.5C9.5 9.83696 9.76339 9.20107 10.2322 8.73223C10.7011 8.26339 11.337 8 12 8C12.663 8 13.2989 8.26339 13.7678 8.73223C14.2366 9.20107 14.5 9.83696 14.5 10.5C14.5 11.163 14.2366 11.7989 13.7678 12.2678C13.2989 12.7366 12.663 13 12 13Z'
        fill='#2C3436'
      />
    </svg>
  );
};
